var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tls-travel-purpose-subtype-selection" }, [
    _c(
      "div",
      {
        ref: "carouselContainer",
        staticClass: "tls-nav-tabs-visa-type-pills",
        class: { "--center": _vm.centralizeCarousel }
      },
      [
        _c(
          "button",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showPreviousButton,
                expression: "showPreviousButton"
              }
            ],
            staticClass: "tls-nav-tabs-visa-type-pills-arrow",
            on: {
              click: function($event) {
                return _vm.selectPreviousTheme()
              }
            }
          },
          [
            _c(
              "div",
              [_c("font-awesome-icon", { attrs: { icon: "chevron-left" } })],
              1
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            ref: "carouselItems",
            staticClass: "tls-nav-tabs-visa-type-pills-group",
            style: {
              transform: "translateX(-" + _vm.carouselItemsTransform + "px)"
            }
          },
          _vm._l(_vm.travelPurposeDisplay, function(travelPurpose, index) {
            return _c(
              "div",
              {
                key: _vm._.get(travelPurpose, "code"),
                ref: "carousel-item-" + index,
                refInFor: true,
                staticClass: "tls-nav-tabs-visa-type-pills-group--slot",
                on: {
                  click: function($event) {
                    return _vm.selectTheme(index)
                  }
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "tls-pill-image-visa-type",
                    class:
                      travelPurpose === _vm.travelPurposeThemeSelected
                        ? "-active"
                        : "",
                    attrs: { "data-tls-value": "thumbnail-travelpurpose" }
                  },
                  [
                    _vm._.get(travelPurpose, "image.data.url")
                      ? _c(
                          "div",
                          { staticClass: "tls-pill-image-visa-type--img" },
                          [
                            _c("img", {
                              attrs: {
                                src: _vm._.get(travelPurpose, "image.data.url"),
                                alt: _vm._.get(travelPurpose, "code") + "logo"
                              }
                            })
                          ]
                        )
                      : _c(
                          "div",
                          { staticClass: "tls-pill-image-visa-type--text" },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm._.get(travelPurpose, "code") + "logo"
                                ) +
                                "\n                    "
                            )
                          ]
                        ),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        staticClass:
                          "tls-simple-text -color-main -weight-bold -size-16"
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm._.get(travelPurpose, "title")) +
                            "\n                    "
                        )
                      ]
                    )
                  ]
                )
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _vm.showNextButton
          ? _c(
              "button",
              {
                staticClass: "tls-nav-tabs-visa-type-pills-arrow",
                on: {
                  click: function($event) {
                    return _vm.selectNextTheme()
                  }
                }
              },
              [
                _c(
                  "div",
                  [
                    _c("font-awesome-icon", {
                      attrs: { icon: "chevron-right" }
                    })
                  ],
                  1
                )
              ]
            )
          : _vm._e()
      ]
    ),
    _vm._v(" "),
    _vm.travelPurposeThemeSelected
      ? _c(
          "div",
          {
            staticClass: "tls-nav-tabs-visa-type-pills-info",
            attrs: { "data-tls-component": "visasubtypes" }
          },
          [
            _c("h2", { staticClass: "tls-heading-2" }, [
              _vm._v(
                _vm._s(
                  _vm._.get(_vm.travelPurposeThemeSelected, "title") ||
                    _vm._.get(_vm.travelPurposeThemeSelected, "code")
                )
              )
            ]),
            _vm._v(" "),
            _c("div", {
              directives: [
                {
                  name: "dompurify-html",
                  rawName: "v-dompurify-html",
                  value: _vm._.get(
                    _vm.travelPurposeThemeSelected,
                    "description"
                  ),
                  expression: "_.get(travelPurposeThemeSelected, 'description')"
                }
              ],
              staticClass: "tls-simple-text -size-16"
            }),
            _vm._v(" "),
            _vm._l(
              _vm._.sortBy(
                _vm._.get(
                  _vm._.find(_vm.cmsData, {
                    travelPurpose: { code: _vm.travelPurposeThemeSelected.code }
                  }),
                  "visaTypes"
                ),
                "weight"
              ),
              function(visaType) {
                return _c(
                  "div",
                  {
                    key: visaType.stay + "-" + visaType.code,
                    staticClass: "tls-tabs-visa-type-card"
                  },
                  [
                    _vm.getVisaSubtypeDocumentUrl(visaType)
                      ? _c(
                          "div",
                          { staticClass: "tls-tab-content-paragraph" },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "tls-link",
                                attrs: {
                                  "data-tls-value": "visasubtype",
                                  target: "_blank",
                                  rel: "noopener",
                                  href: _vm.getVisaSubtypeDocumentUrl(visaType)
                                }
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.getShowVisaTypeText(visaType)) +
                                    "\n                "
                                )
                              ]
                            )
                          ]
                        )
                      : _c(
                          "div",
                          { staticClass: "tls-tab-content-paragraph" },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "tls-simple-text -color-main -weight-bold -size-16",
                                attrs: { "data-tls-value": "visasubtype" }
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.getShowVisaTypeText(visaType)) +
                                    "\n                "
                                )
                              ]
                            )
                          ]
                        ),
                    _vm._v(" "),
                    _c("div", {
                      directives: [
                        {
                          name: "dompurify-html",
                          rawName: "v-dompurify-html",
                          value: _vm._.get(
                            visaType,
                            "visa_types_content.description"
                          )
                            ? _vm._.get(
                                visaType,
                                "visa_types_content.description"
                              )
                            : _vm._.get(visaType, "description"),
                          expression:
                            "_.get(visaType, 'visa_types_content.description') ? _.get(visaType, 'visa_types_content.description') : _.get(visaType, 'description')"
                        }
                      ],
                      staticClass: "tls-simple-text -size-16"
                    })
                  ]
                )
              }
            )
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }